import React from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// import constants
import { ALL_URLS } from 'js/constants/Pages';

// import components
import ButtonWithIcon from 'js/components/button/Button.with-icon';

// import selectors
import { getTranslationById } from 'js/store/app/App.selectors';

const FindConfirmButton = () => {
  const navigate = useNavigate();
  const doneLabel = useSelector((state) => getTranslationById(state, 'find_step_2_done', 'Done'));

  return (
    <div style={{ marginTop: '20px' }}>
      <ButtonWithIcon
        title={doneLabel}
        iconName={'tick'}
        iconPosition={'right'}
        style={{
          borderRadius: '36px',
          boxShadow: '0 10px 20px 0 rgba(0, 0, 0, 0.25)',
          margin: 'auto',
          padding: '15px 25px 15px 50px',
          fontSize: 26,
        }}
        action={() => navigate(ALL_URLS.results, { state: { internal: true } })}
      />
    </div>
  );
};

export default FindConfirmButton;
